module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-banner-th.49bfc778.png";